import { CajaCurricularI } from "interfaces/CajaCurricular";
import { ReactNode, useState } from "react";
import { horasPorCuatrimestre } from "components/EspaciosTable/EspaciosTable";

interface Props {
  elemento: CajaCurricularI;
  renderActions?: (elemento: CajaCurricularI) => ReactNode;
}

export const CajasCurricularesRow = ({ elemento, renderActions }: Props) => {
  const horas = horasPorCuatrimestre(
    elemento.espaciosCurriculares.map((e) => ({
      horasSemanales: e.horas_semanales,
      cuatrimestre: e.cuatrimestre,
    })),
  );

  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>
          {elemento.espaciosCurriculares.map((ctE) => ctE.nombre).join(" - ")}
        </td>
        <td>{elemento.planesEstudio.map((ctE) => ctE.nombre).join(" - ")}</td>
        <td>
          1C: {horas.c1} / 2C: {horas.c2}
        </td>
        <td>
          #{elemento.espaciosCurriculares.length}
        </td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
